import { useMemo } from 'react';

export const DOTS = '...';
export const VISIBLE_RANGE = 5; // < 1, 2, 3, 4, 5 >

export const usePagination = (currentPage: number, maxPages: number) => {
  const firstPage = 1;
  const lastPage = maxPages;

  const previousPage = currentPage - 1;
  const nextPage = currentPage + 1;

  const paginationRange = useMemo(() => {
    if (lastPage <= VISIBLE_RANGE) {
      return [...Array(lastPage)].map((_, index) => index + 1);
    }

    if (currentPage === firstPage) {
      return [firstPage, nextPage, DOTS, lastPage];
    }
    if (currentPage === lastPage) {
      return [firstPage, DOTS, previousPage, lastPage];
    }

    if (previousPage === firstPage) {
      return [firstPage, currentPage, nextPage, DOTS, lastPage];
    }
    if (nextPage === lastPage) {
      return [firstPage, DOTS, previousPage, currentPage, lastPage];
    }
    return [
      firstPage,
      DOTS,
      previousPage,
      currentPage,
      nextPage,
      DOTS,
      lastPage,
    ];
  }, [currentPage, lastPage, nextPage, previousPage]);

  return paginationRange;
};
